module.exports = __webpack_public_path__ + "img/icon_trade.38f9eb73.svg";